import React, { useState } from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import DeleteText from "components/common/style/navigation/DeleteText";
import { useGroupSearch } from "hooks/citajteo/dl_group/useGroupSearch";
import { useGroupDelete } from "hooks/citajteo/dl_group/useGroupDelete";
import { QUERY_KEYS } from "constant/react_query";
import { DlGroup } from "type/dl_group/dl_group.type";
import toast from "react-hot-toast";
import ConfirmModal from "components/UI/modal/ConfirmModal";

const DlGroupList: React.FC = () => {
  const dlGroups = useGroupSearch();
  const { groupDeleteMutate } = useGroupDelete({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_GROUP_SEARCH],
  });
  const [groupToDelete, setGroupToDelete] = useState<DlGroup | null>(null);

  const handleGroupDelete = (group: DlGroup) => {
    setGroupToDelete(group);
  };

  const handleConfirmDelete = () => {
    if (!groupToDelete) {
      return;
    }

    const group = groupToDelete;
    groupDeleteMutate(group.id, {
      onSuccess: () => {
        toast.success("Uspešno brisanje odrednice.");
        setGroupToDelete(null);
      },
      onError: (error) => {
        console.error("Error deleting group:", error);
        toast.error("Greška prilikom brisanja odrednice.");
        setGroupToDelete(null);
      },
    });
  };

  return (
    <Content>
      <ContentInner>
        <NewItem>
          <AppLink to="/admin-dashboard/dl-group-new">novo</AppLink>
        </NewItem>

        {dlGroups &&
          dlGroups.items.length > 0 &&
          dlGroups.items.map((item: DlGroup) => (
            <ListItem key={item.id}>
              <AppLink to={`/admin-dashboard/dl-group-edit/${item.id}`}>
                polja
              </AppLink>
              <br />
              {item.slug.replace(/-/g, " ")}
              <DeleteItem>
                <DeleteText onClick={() => handleGroupDelete(item)}>
                  obriši
                </DeleteText>
              </DeleteItem>
            </ListItem>
          ))}
      </ContentInner>
      <ConfirmModal
        open={groupToDelete !== null}
        title="Brisanje odrednice"
        message={
          groupToDelete
            ? `Da li želite da obrišete odrednicu ${groupToDelete.slug.replace(/-/g, " ")}?`
            : ""
        }
        confirmLabel="Obriši"
        cancelLabel="Otkaži"
        onConfirm={handleConfirmDelete}
        onCancel={() => setGroupToDelete(null)}
      />
    </Content>
  );
};

export default DlGroupList;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteItem = styled.div`
  margin-top: 0.5rem;
`;
